import Button from "@/components/bricks/button/Button";
import PlusIcon from "../../icons/PlusIcon";
import Modal, {
  ModalContext,
  ModalProvider,
  ModalTrigger,
} from "../../Modal/Modal";
import OpretKursusIcon from "../../icons/OpretKursusIcon";
import OpretKursusLinjeStep1 from "./OpretKursusLinjeStep1";
import OpretLinjeStep2 from "./OpretLinjeStep2";
import { useOpretKursusLinje } from "./useOpretKursusLinje";
import { useContext } from "react";
import OpretKursusReceipt from "./OpretKursusReceipts";
import OpretLinjeReceipt from "./OpretLinjeReceipts";
import { useKodeListe } from "../../../hooks/useQueries";

const OpretKursusModal = (props: { fmuKursusKategorier: KodeListe[] }) => {
  const { fmuKursusKategorier } = props;

  const { setModalOpen } = useContext(ModalContext);
  const { step1, step2, step, setStep, opretKursusQuery, opretLinjeQuery } =
    useOpretKursusLinje(fmuKursusKategorier ?? []);

  return (
    <Modal
      dialog
      title={
        <>
          <OpretKursusIcon width={26} /> Opret nyt kursus eller ny linje
          <span className="c-modal-steps">
            {step === 1 && (
              <>
                1 / {step1.values.kursusOrLinje === "kursus" && "1"}
                {step1.values.kursusOrLinje === "linje" && "2"}
              </>
            )}
            {step === 2 && "2 / 2"}
          </span>
        </>
      }
      description=""
      onErrorReset={() => {
        setStep(1);
      }}
    >
      <div className="c-modal-container">
        {step === 1 && (
          <OpretKursusLinjeStep1
            step1={step1}
            setModalOpen={setModalOpen}
            step2={step2}
            opretKursusQueryisLoading={opretKursusQuery.isPending}
          />
        )}
        {step === 2 && (
          <OpretLinjeStep2
            step1={step1}
            step2={step2}
            setStep={setStep}
            isPosting={opretLinjeQuery.isPending}
            fmuKursusKategorier={fmuKursusKategorier}
          />
        )}
        {step === "kursuskvittering" && (
          <OpretKursusReceipt
            opretKursusQuery={opretKursusQuery}
            setStep={setStep}
            step1={step1}
            step2={step2}
          />
        )}
        {step === "linjekvittering" && (
          <OpretLinjeReceipt
            opretLinjeQuery={opretLinjeQuery}
            setStep={setStep}
            step1={step1}
            step2={step2}
          />
        )}
      </div>
    </Modal>
  );
};

const OpretKursusLinje = () => {
  const { kodeliste: fmuKursusKategorier } = useKodeListe("FmukursusKategori");

  return (
    <ModalProvider>
      <ModalTrigger asChild>
        <Button className="mx-3" transparent color="primary" onClick={() => {}}>
          <PlusIcon width={18} /> Opret kursus
        </Button>
      </ModalTrigger>
      {fmuKursusKategorier && fmuKursusKategorier.length > 7 && (
        <OpretKursusModal fmuKursusKategorier={fmuKursusKategorier} />
      )}
    </ModalProvider>
  );
};

export default OpretKursusLinje;
